module.exports = __webpack_public_path__ + "static/media/Dickinson-Students-Shopping-on-Pomfret_20210526_LOH_38--resized.cfb8b86b.jpg";